import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { WidgetSnippetService } from './widget-snippet.service';
import {
  WidgetSnippetVersionsLoadedAction,
  ProjectCodeSnippetInitializedAction,
  WidgetSnippetVersionsRequestErroredAction,
} from './widget-snippet.actions';

@Injectable()
export class WidgetSnippetEffects {
  loadVersions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectCodeSnippetInitializedAction),
      switchMap(() =>
        this.widgetSnippetService.loadVersions().pipe(
          map((versions) => WidgetSnippetVersionsLoadedAction({ versions })),
          catchError(() => of(WidgetSnippetVersionsRequestErroredAction())),
        ),
      ),
    ),
  );

  constructor(protected actions$: Actions, protected widgetSnippetService: WidgetSnippetService) {}
}
